export enum PlaceLimitRuleType {
  DEVICE_TYPE = 'DEVICE_TYPE',
  DEVICES = 'DEVICES',
  DEVICE_TYPE_ALL_DEVICES = 'DEVICE_TYPE_ALL_DEVICES',
}

export interface PlaceLimitRule {
  id: string;
  type: PlaceLimitRuleType;
  name: string;
  deviceTypeId?: string;
  zone: {
    id: string;
    name: string;
  }[];
  devices: {
    uuid: string;
    uniqueId: string;
  }[];
  deviceType: {
    id: string;
    name: string;
  }[];
  limits: {
    objectId: string;
    value: number;
    type: 'NORMAL' | 'DANGEROUS';
  }[];
  dangerousSum: number;
  normalSum: number;
}

export const typeToLabel = {
  [PlaceLimitRuleType.DEVICE_TYPE]: 'Typ urządzenia',
  [PlaceLimitRuleType.DEVICES]: 'Urządzenia',
  [PlaceLimitRuleType.DEVICE_TYPE_ALL_DEVICES]:
    'Typ urządzenia i strefy dla indywidualnych urządzeń',
};
